import { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function Settings() {
  const { user, setUser } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const payload = { name };
      if (password) payload.password = password;
      const { data } = await api.put(`/users/${user.id}`, payload);
      setUser(data);
      localStorage.setItem("taxinpho_user", JSON.stringify(data));
      setPassword("");
      toast.success("Saved");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Save failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="p-6 md:p-8 max-w-3xl">
      <div className="mb-8">
        <p className="label-caps mb-2">Account</p>
        <h1 className="font-display font-black text-4xl tracking-tighter">Settings</h1>
      </div>

      <div className="bg-white border border-zinc-200 p-6 mb-6">
        <h2 className="font-display font-bold text-xl tracking-tight mb-4">Profile</h2>
        <form onSubmit={save} className="space-y-4 max-w-md">
          <div>
            <label className="label-caps block mb-2">Email</label>
            <input value={user?.email || ""} disabled className="w-full border border-zinc-300 px-3 py-2 bg-zinc-50 font-mono text-sm" />
          </div>
          <div>
            <label className="label-caps block mb-2">Role</label>
            <input value={user?.role || ""} disabled className="w-full border border-zinc-300 px-3 py-2 bg-zinc-50 uppercase font-semibold text-sm" />
          </div>
          <div>
            <label className="label-caps block mb-2">Name</label>
            <input value={name} onChange={e => setName(e.target.value)} data-testid="settings-name" className="w-full border border-zinc-300 px-3 py-2 focus:outline-none focus:border-zinc-900" />
          </div>
          <div>
            <label className="label-caps block mb-2">New Password (leave blank to keep)</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} data-testid="settings-password" className="w-full border border-zinc-300 px-3 py-2 focus:outline-none focus:border-zinc-900" />
          </div>
          <button type="submit" disabled={busy || (user?.role !== "admin")} data-testid="save-settings" className="bg-zinc-900 text-white px-4 py-2 font-semibold hover:bg-zinc-800 disabled:opacity-50">
            {busy ? "Saving..." : "Save changes"}
          </button>
          {user?.role !== "admin" && (
            <p className="text-xs text-zinc-500">Only admins can update their own profile in this version.</p>
          )}
        </form>
      </div>

      <div className="bg-white border border-zinc-200 p-6">
        <h2 className="font-display font-bold text-xl tracking-tight mb-2">About TAXINPHO</h2>
        <p className="text-sm text-zinc-600 mb-4">CA Office Operating System · v1.0</p>
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            <div className="label-caps mb-1">Built for</div>
            <div className="font-medium">Chartered Accountants in India</div>
          </div>
          <div>
            <div className="label-caps mb-1">AI Engine</div>
            <div className="font-mono">GPT-5.2 · OpenAI</div>
          </div>
        </div>
      </div>
    </div>
  );
}
